module.exports = __webpack_public_path__ + "static/assets/a6363d62e5405e1e12db5a5979c18adc.svg";